<template>
  <div>
    <TopHeader code="course" />

    <section class="container-fluid uc-bg2">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="uc-crumb">
              <router-link to="/" class="item">首页</router-link>
              <router-link :to="{ name: 'Course' }" class="item"
                >课程</router-link
              >
              <router-link to="" class="item">课程详情</router-link>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-24">
            <section class="uc-CourseDetailBox">
              <div class="banner-box">
                <img src="../../assets/images/banner.jpg" />
                <div class="txt">
                  {{ model.name }}
                  <div class="star-box">
                    <el-rate
                      disabled
                      show-score
                      text-color="#ff9900"
                      :value="model.evaluation_score"
                      :score-template="(model.evaluation_score || '--') + '分'"
                    >
                    </el-rate>
                  </div>
                </div>
                <div class="right">
                  <!--<div
                    class="btn-storage uc-pr50"
                    hover-class="none"
                    @click="shareDialogVisible = true"
                  >
                    <el-tooltip content="分享" placement="top">
                      <img
                        src="../../assets/images/icon-share.png"
                        alt="分享"
                        class="uc-icon20"
                      />
                    </el-tooltip>
                  </div>-->
                  <div
                    class="btn-storage uc-pr50"
                    hover-class="none"
                    @click="btnLike"
                  >
                    <img
                      v-if="!isLiked"
                      src="../../assets/images/like.png"
                      class="uc-icon24"
                      title="点赞"
                    />
                    <img
                      v-if="isLiked"
                      src="../../assets/images/like-on.png"
                      class="uc-icon24"
                      title="取消点赞"
                    />
                  </div>
                  <div
                    class="btn-storage"
                    hover-class="none"
                    @click="btnStorage"
                  >
                    <img
                      v-if="!isStorage"
                      src="../../assets/images/icon-storage.png"
                      class="uc-icon24"
                      title="点击收藏"
                    />
                    <img
                      v-if="isStorage"
                      src="../../assets/images/icon-storage-on.png"
                      class="uc-icon24"
                      title="取消收藏"
                    />
                  </div>
                  <div
                    class="chart-box"
                    id="myProcessChart"
                    style="width: 200px; height: 200px"
                  ></div>
                  <!-- <div class="chart-box">
                    <el-progress
                      type="dashboard"
                      :percentage="percentage"
                      :color="colors"
                    >
                    </el-progress>
                  </div> -->
                </div>
              </div>
              <div class="btm">
                <div class="left">
                  <div class="info">
                    <div class="item">
                      <i class="el-icon-time"></i>
                      <span class="uc-pl5"></span>
                      课时：{{ model.period }}分钟
                    </div>
                    <div class="item">
                      <i class="el-icon-coin"></i>
                      <span class="uc-pl5"></span>
                      学分：{{ model.score || '--' }}分
                    </div>
                    <div class="item">
                      <i class="el-icon-watch"></i>
                      <span class="uc-pl5"></span>
                      累计学习：{{
                        model.learn_duration == null
                          ? '--'
                          : (model.learn_duration / 60).toFixed(1)
                      }}分钟
                    </div>
                    <div class="item">
                      <i class="el-icon-set-up"></i>
                      <span
                        class="uc-pl5"
                        v-html="
                          model.cert_tpl_id == 0
                            ? '无证书'
                            : model.certificate == null
                            ? '未获得证书'
                            : `<a href='${model.certificate.cert_url}' target=_blank>查看证书</a>`
                        "
                      >
                      </span>
                    </div>
                    <div class="item" v-if="model.start_time && model.end_time">
                      <i class="el-icon-date"></i>
                      <span class="uc-pl5"></span>
                      {{ model.start_time }} ~ {{ model.end_time }}
                    </div>
                  </div>
                </div>
                <div class="operate">
                  <router-link
                    v-if="model.is_valid === true"
                    :to="{
                      name: 'CoursePlay',
                      params: { id: query.id },
                      query: {
                        isRequired: this.$route.query.isRequired,
                      },
                    }"
                    class="uc-btn black"
                    target="_blank"
                  >
                    播放 <i class="uc-font uc-next"></i>
                  </router-link>
                  <a
                    v-if="model.is_valid === false"
                    href="javascript:;"
                    class="uc-btn gray"
                    >{{ model.is_valid_text }}</a
                  >
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg uc-pt20 uc-pb40">
      <div class="container">
        <div class="row">
          <div class="col-24 col-sm-17">
            <section class="uc-CourseDetailContent uc-mr10">
              <div class="tabHeader" :class="tab == 'tab3' ? 'noBorder' : ''">
                <div
                  :class="tab == 'tab1' ? 'item on' : 'item'"
                  @click="tab = 'tab1'"
                >
                  课程概述
                </div>
                <div
                  :class="tab == 'tab2' ? 'item on' : 'item'"
                  @click="
                    tab = 'tab2';
                    loadEvaluationData();
                  "
                >
                  课程评价
                </div>
                <div
                  :class="tab == 'tab3' ? 'item on' : 'item'"
                  @click="
                    tab = 'tab3';
                    loadNoteData();
                  "
                >
                  学习笔记
                </div>
                <div
                  :class="tab == 'tab4' ? 'item on' : 'item'"
                  @click="tab = 'tab4'"
                  v-if="model.exam_id > 0"
                >
                  课程考试
                </div>
                <div
                  :class="tab == 'tab5' ? 'item on' : 'item'"
                  @click="tab = 'tab5'"
                  v-if="model.qst_id > 0"
                >
                  课程问卷
                </div>
                <div
                  :class="tab == 'tab6' ? 'item on' : 'item'"
                  @click="
                    tab = 'tab6';
                    loadDiscussData();
                  "
                >
                  课程讨论
                </div>
                <div
                  :class="tab == 'tab7' ? 'item on' : 'item'"
                  @click="
                    tab = 'tab7';
                    loadFeedbackData();
                  "
                >
                  课程反馈
                </div>
              </div>

              <div v-if="tab == 'tab1'">
                <div class="box1">
                  <h3>讲师</h3>
                  <div class="con">
                    {{ model.lecturer_name || '无讲师' }}
                  </div>
                  <h3>讲师简介</h3>
                  <div class="con">
                    {{ model.lecturer_description }}
                  </div>
                  <h3>课程标签</h3>
                  <div class="con">
                    <span
                      style="margin-right: 10px"
                      v-for="(v, i) in model.course_tage_items"
                      :key="i"
                      >{{ v.label }}</span
                    >
                  </div>
                  <h3>关键词</h3>
                  <div class="con">
                    <el-button
                      size="mini"
                      round
                      v-for="(v, i) in (model.keyword || '').split(',')"
                      :key="i"
                      @click.native="
                        $router.push({ name: 'Course', query: { keyword: v } })
                      "
                      >{{ v }}</el-button
                    >
                  </div>
                  <h3>简介</h3>
                  <div class="con">
                    {{ model.description }}
                  </div>
                </div>
              </div>
              <!-- 课程评价 -->
              <div v-if="tab == 'tab2'">
                <div class="discuss-box" v-show="!isEvaluation">
                  <h3>发表你的评价</h3>
                  <!-- 我要评分 -->
                  <div class="item">
                    <span class="txt">我要评分</span>
                    <div class="star">
                      <el-rate
                        v-model="myEvaluationScore"
                        show-score
                        text-color="#ff9900"
                        score-template="{value}分"
                      >
                      </el-rate>
                    </div>
                  </div>
                  <textarea
                    class="uc-textarea"
                    v-model="evaluationContent"
                    placeholder="请输入评价内容"
                    cols="30"
                    rows="10"
                  ></textarea>
                  <div class="operate">
                    <button
                      class="uc-btn blue"
                      hover-class="none"
                      @click="btnSubmitCourseEvaluation"
                    >
                      发表
                    </button>
                  </div>
                </div>
                <!-- 综合评分 -->
                <div class="discuss-total" v-show="isEvaluation">
                  <div class="item">
                    <span class="txt">我的评分</span>
                    <div class="star">
                      <el-rate
                        disabled
                        show-score
                        text-color="#ff9900"
                        :value="myEvaluationScore"
                        score-template="{value}分"
                      >
                      </el-rate>
                    </div>
                  </div>
                </div>
                <!-- 评价内容 -->
                <div class="discuss-list">
                  <div
                    v-for="(item, index) in evaluationList.items"
                    :key="index"
                    class="item"
                  >
                    <div class="face-box">
                      <img :src="item.avatar" />
                    </div>
                    <div class="right">
                      <h3>
                        {{ item.create_user_name
                        }}<img
                          class="icon-credit"
                          :src="item.credit_icon"
                          :alt="item.credit_name"
                          v-if="item.credit_icon"
                        /><span v-else>--{{ item.credit_name }}</span>
                        <span style="font-size: 14px">
                          &nbsp;&nbsp; {{ item.create_time }}</span
                        >
                      </h3>
                      <div class="con">
                        <p>{{ item.content }}</p>
                      </div>
                    </div>
                  </div>
                  <el-pagination
                    class="uc-prvNxt"
                    background
                    layout="prev, pager, next"
                    hide-on-single-page
                    :current-page="queryEvaluation.pageIndex"
                    :page-size="queryEvaluation.pageSize"
                    :total="evaluationList.total_count"
                    @current-change="handleEvaluationCurrentChange"
                  >
                  </el-pagination>
                </div>
              </div>
              <!-- 课程笔记 -->
              <div v-if="tab == 'tab3'">
                <div class="box1">
                  <div class="textarea-box">
                    <textarea
                      class="uc-textarea"
                      placeholder="添加对课程的记录、想法、感悟在日后复习回顾过程中将会有很大帮助"
                      cols="30"
                      rows="10"
                      v-model="noteContent"
                    ></textarea>
                    <button
                      class="uc-btn blue"
                      hover-class="none"
                      @click="btnSubmitCourseNote(0)"
                    >
                      保存
                    </button>
                  </div>
                  <div class="con">
                    <div v-for="(item, index) in noteList.items" :key="index">
                      <p>{{ index + 1 }}. {{ item.content }}</p>
                      <div
                        :id="`note_div_${item.id}`"
                        class="textarea-box"
                        style="display: none"
                      >
                        <textarea
                          :id="`note_txt_${item.id}`"
                          class="uc-textarea"
                          cols="30"
                          rows="10"
                          :value="item.content"
                        >
                        </textarea>
                        <button
                          class="uc-btn blue"
                          hover-class="none"
                          @click="btnSubmitCourseNote(item.id)"
                        >
                          修改
                        </button>
                      </div>
                      <p class="tRight">
                        {{ item.create_time }}
                        <router-link to class="uc-ml30">
                          <el-tooltip content="编辑" placement="top">
                            <i
                              class="el-icon-edit"
                              @click="editNote(item.id)"
                            ></i>
                          </el-tooltip>
                        </router-link>
                        <router-link to class="uc-ml30">
                          <el-tooltip content="删除" placement="top">
                            <i
                              class="el-icon-delete"
                              @click="btnDelCourseNote(item.id)"
                            ></i>
                          </el-tooltip>
                        </router-link>
                      </p>
                    </div>
                  </div>
                </div>
                <el-pagination
                  class="uc-prvNxt"
                  background
                  layout="prev, pager, next"
                  hide-on-single-page
                  :current-page="queryNote.pageIndex"
                  :page-size="queryNote.pageSize"
                  :total="noteList.total_count"
                  @current-change="handleNoteCurrentChange"
                >
                </el-pagination>
              </div>
              <!-- 考试 -->
              <div v-if="tab == 'tab4'">
                <section class="uc-examList">
                  <div class="content-empty" v-show="!model.exam_paper">
                    <div class="emptyimg-box"></div>
                    <p>暂无相关内容</p>
                  </div>
                  <div v-if="model.exam_paper" class="item">
                    <a
                      class="title"
                      @click="handleExamClick(model)"
                      style="cursor: pointer"
                    >
                      <img
                        src="../../assets/images/icon130.png"
                        class="uc-icon20"
                        v-if="model.exam_paper.exam_status == 0"
                      />
                      <img
                        src="../../assets/images/icon131.png"
                        class="uc-icon20"
                        v-if="
                          model.exam_paper.exam_status == 1 &&
                          model.exam_paper.is_pass == 0
                        "
                      />
                      <img
                        src="../../assets/images/icon132.png"
                        class="uc-icon20"
                        v-if="
                          model.exam_paper.exam_status == 1 &&
                          model.exam_paper.is_pass == 1
                        "
                      />
                      <img
                        src="../../assets/images/icon133.png"
                        class="uc-icon20"
                        v-if="model.exam_paper.exam_status == 2"
                      />
                      <div class="c">
                        {{ model.exam_paper.name }}
                        <span
                          v-if="model.exam_paper.exam_status == 1"
                          class="uc-phColor"
                          >（{{ model.exam_paper.user_score }}分）</span
                        >
                      </div>
                      <span class="uc-font uc-next"></span>
                    </a>
                    <div class="con">
                      <!-- <div class="sub-item">开始时间：{{ model.start_time }}</div>
                    <div class="sub-item">结束时间：{{ model.end_time }}</div> -->
                      <div class="sub-item">
                        试卷总分：{{ model.exam_paper.total_score }}分
                      </div>
                      <div class="sub-item">
                        通过分数：{{ model.exam_paper.pass_score }}分
                      </div>
                      <div class="sub-item">
                        考试时长：{{
                          model.exam_paper.duration == 0
                            ? '不限'
                            : model.exam_paper.duration + '分钟'
                        }}
                      </div>
                      <div class="sub-item">
                        出题方式：{{
                          model.exam_paper.question_way == 1 ? '随机' : '固定'
                        }}
                      </div>
                      <div class="sub-item">
                        评分方式：{{
                          (model.exam_paper.score_way = 1 ? '自动' : '手工')
                        }}
                      </div>
                      <div class="sub-item">
                        可考次数：{{
                          model.exam_paper.allow_times == 0
                            ? '不限'
                            : model.exam_paper.allow_times + '次'
                        }}
                      </div>
                      <!-- <div class="sub-item">
                      考试次数：{{ model.allow_times }}
                    </div>
                    <div class="sub-item">
                      <i class="e2">期</i>限： {{ model.start_time }} ~
                      {{ model.end_time }}
                    </div> -->
                    </div>
                    <div
                      class="operate"
                      v-if="
                        model.exam_paper.exam_status == 1 &&
                        model.exam_paper.config > 0
                      "
                    >
                      <router-link
                        :to="{
                          name: 'ExamStatistics',
                          params: { id: model.exam_paper.answer_id },
                        }"
                        target="_blank"
                        class="uc-btn blue-plain"
                        hover-class="none"
                        v-if="(model.exam_paper.config & 2) == 2"
                        >查看分数</router-link
                      >
                      <router-link
                        :to="{
                          name: 'ExamWrong',
                          params: { id: model.exam_paper.answer_id },
                        }"
                        target="_blank"
                        class="uc-btn blue-plain"
                        hover-class="none"
                        v-if="(model.exam_paper.config & 8) == 8"
                        >查看错题</router-link
                      >
                      <router-link
                        :to="{
                          name: 'ExamRecord',
                          params: { id: model.exam_paper.answer_id },
                        }"
                        target="_blank"
                        class="uc-btn blue-plain"
                        hover-class="none"
                        v-if="(model.exam_paper.config & 1) == 1"
                        >查看答案</router-link
                      >
                      <router-link
                        :to="{
                          name: 'ExamRanking',
                          params: { id: model.exam_paper.id },
                        }"
                        target="_blank"
                        class="uc-btn blue-plain"
                        hover-class="none"
                        v-if="(model.exam_paper.config & 4) == 4"
                        >查看排名</router-link
                      >
                    </div>
                  </div>
                </section>
              </div>
              <!-- 问卷 -->
              <div v-if="tab == 'tab5'">
                <section class="uc-examList">
                  <div class="content-empty" v-if="!model.questionnaire">
                    <div class="emptyimg-box"></div>
                    <p>暂无相关内容</p>
                  </div>
                  <div v-if="model.questionnaire" class="item">
                    <router-link
                      to=""
                      class="title"
                      @click.native="handleQstClick(model)"
                    >
                      <img
                        src="../../assets/images/icon133.png"
                        class="uc-icon20"
                        v-if="model.questionnaire.answer_status == 0"
                      />
                      <img
                        src="../../assets/images/icon132.png"
                        class="uc-icon20"
                        v-if="model.questionnaire.answer_status == 1"
                      />
                      <img
                        src="../../assets/images/icon130.png"
                        class="uc-icon20"
                        v-if="model.questionnaire.answer_status == 2"
                      />
                      <div class="c">
                        {{ model.questionnaire.name }}
                        <span class="uc-phColor">
                          （{{
                            model.questionnaire.answer_status == 0
                              ? '未作答'
                              : model.questionnaire.answer_status == 1
                              ? '已完成'
                              : '进行中'
                          }}）</span
                        >
                      </div>
                      <span class="uc-font uc-next"></span>
                    </router-link>
                    <div class="con">
                      {{ model.questionnaire.description }}
                    </div>
                  </div>
                </section>
              </div>
              <!-- 课程讨论 -->
              <div v-if="tab == 'tab6'">
                <div class="discuss-box">
                  <h3>发表你的讨论</h3>
                  <!-- 我要评分 -->
                  <div class="item">
                    <span class="txt">我要讨论</span>
                  </div>
                  <textarea
                    class="uc-textarea"
                    v-model="discussContent"
                    placeholder="请输入讨论内容"
                    cols="30"
                    rows="10"
                  ></textarea>
                  <div class="operate">
                    <button
                      class="uc-btn blue"
                      hover-class="none"
                      @click="btnSubmitCourseDiscuss"
                    >
                      发表
                    </button>
                  </div>
                </div>
                <!-- 讨论内容 -->
                <div class="discuss-list">
                  <div
                    v-for="(item, index) in discussList.items"
                    :key="index"
                    class="item"
                  >
                    <div class="face-box">
                      <img :src="item.avatar" />
                    </div>
                    <div class="right">
                      <h3>
                        {{ item.create_user_name
                        }}<img
                          class="icon-credit"
                          :src="item.credit_icon"
                          :alt="item.credit_name"
                          v-if="item.credit_icon"
                        />
                        <span v-else>--{{ item.credit_name }}</span>
                        <span style="font-size: 14px">
                          &nbsp;&nbsp; {{ item.create_time }}</span
                        >
                      </h3>

                      <div class="con">
                        <p>{{ item.content }}</p>
                      </div>

                      <div
                        class="huifu-btn"
                        @click="changeCommenter1(item.create_user_name, index)"
                      >
                        回复
                      </div>
                      <div class="commentBox" v-show="_binputkShow1(index)">
                        <textarea
                          class="uc-textarea"
                          v-model="replyContent1"
                          placeholder="请填写回复内容"
                          cols="30"
                          rows="3"
                        ></textarea>
                        <el-button
                          class="btn"
                          type="primary"
                          round
                          @click="addComment1(index)"
                          >回复</el-button
                        >
                        <el-button
                          class="btn"
                          type="warning"
                          round
                          @click="canelCommit1(index)"
                          >取消</el-button
                        >
                      </div>
                      <div
                        v-if="
                          item.course_discuss_reply_list != null &&
                          item.course_discuss_reply_list.length > 0
                        "
                      >
                        <div
                          class="reply"
                          v-for="(reply, r) in item.course_discuss_reply_list"
                          :key="r"
                        >
                          <p>
                            {{
                              reply.create_user_name
                            }}&nbsp;&nbsp;回复&nbsp;&nbsp;{{ reply.reviewers }}
                            <span>{{ reply.create_time }}</span>
                          </p>
                          <div class="talk-box">
                            <p>
                              {{ reply.reply_content }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <el-pagination
                    class="uc-prvNxt"
                    background
                    layout="prev, pager, next"
                    hide-on-single-page
                    :current-page="queryDiscuss.pageIndex"
                    :page-size="queryDiscuss.pageSize"
                    :total="discussList.total_count"
                    @current-change="handleDiscussCurrentChange"
                  >
                  </el-pagination>
                </div>
              </div>
              <!-- 课程反馈 -->
              <div v-if="tab == 'tab7'">
                <div class="discuss-box" v-show="!isFeedback">
                  <h3>发表你的反馈</h3>
                  <!-- 我要评分 -->
                  <div class="item">
                    <span class="txt">我要反馈</span>
                  </div>
                  <textarea
                    class="uc-textarea"
                    v-model="feedbackContent"
                    placeholder="请输入反馈内容"
                    cols="30"
                    rows="10"
                  ></textarea>
                  <div class="operate">
                    <button
                      class="uc-btn blue"
                      hover-class="none"
                      @click="btnSubmitCourseFeedback"
                    >
                      发表
                    </button>
                  </div>
                </div>
                <!-- 内容 -->
                <div class="discuss-list">
                  <div
                    v-for="(item, index) in feedbackList.items"
                    :key="index"
                    class="item"
                  >
                    <div class="face-box">
                      <img :src="item.avatar" />
                    </div>
                    <div class="right">
                      <h3>
                        {{ item.create_user_name
                        }}<img
                          class="icon-credit"
                          :src="item.credit_icon"
                          :alt="item.credit_name"
                          v-if="item.credit_icon"
                        /><span v-else>--{{ item.credit_name }}</span>
                      </h3>
                      <div class="con">
                        <p>{{ item.content }}</p>
                      </div>

                      <div class="btm">
                        <time>{{ item.create_time }}</time>
                      </div>
                    </div>
                  </div>
                  <el-pagination
                    class="uc-prvNxt"
                    background
                    layout="prev, pager, next"
                    hide-on-single-page
                    :current-page="queryFeedback.pageIndex"
                    :page-size="queryFeedback.pageSize"
                    :total="feedbackList.total_count"
                    @current-change="handleFeedbackCurrentChange"
                  >
                  </el-pagination>
                </div>
              </div>
            </section>
          </div>
          <!-- 相关课程 -->
          <div class="col-24 col-sm-7">
            <section class="g-sideCourseList">
              <div class="title">相关课程</div>
              <div class="content-empty" v-show="courseList.length == 0">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
              <div class="list">
                <div
                  class="item"
                  v-for="(item, index) in courseList"
                  :key="index"
                >
                  <router-link
                    :to="{
                      name: 'CourseDetails',
                      params: { id: item.id },
                    }"
                    class="img-box"
                  >
                    <el-image :src="item.cover">
                      <div slot="error" class="image-slot">
                        <img src="../../assets/images/default-kc.png" />
                      </div>
                    </el-image>
                  </router-link>
                  <div class="con">
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :content="item.name"
                    >
                      <h3>{{ item.name }}</h3>
                    </el-tooltip>
                    <div class="txt">
                      {{ item.lecturer_name || '无讲师' }}
                    </div>
                    <div class="btm">
                      <span class="el-icon-time"> {{ item.period }}分钟 </span>
                      <span class="el-icon-view" style="float: right">
                        {{ item.study_count }}人
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>

    <div>
      <el-dialog
        :visible.sync="shareDialogVisible"
        :close-on-click-modal="false"
        width="25%"
        center
      >
        <span><img src="../../assets/images/code.png" /></span>
        <span slot="footer" class="dialog-footer">
          <p>打开微信扫一扫</p>
          <p class="uc-pt10">点击右上角进行分享</p>
        </span>
      </el-dialog>

      <el-dialog
        title="选择收藏夹"
        :visible.sync="outerVisible"
        :destroy-on-close="true"
        :close-on-click-modal="false"
      >
        <el-dialog
          width="40%"
          title="新建收藏夹"
          :visible.sync="innerVisible"
          :destroy-on-close="true"
          :close-on-click-modal="false"
          :class="handleCloseDialog"
          append-to-body
        >
          <el-form :model="form" ref="form" :rules="rules">
            <el-input v-model="form.id" type="hidden"></el-input>
            <el-form-item
              label="名称"
              prop="name"
              :label-width="formLabelWidth"
            >
              <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="描述" :label-width="formLabelWidth">
              <el-input
                type="textarea"
                v-model.trim="form.description"
                autocomplete="off"
                :rules="{
                  required: true,
                  message: '请输入收藏夹名称',
                  trigger: 'blur',
                }"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click.native="handleCloseFavorites">取 消</el-button>
            <el-button type="primary" @click.native="handleCreateFavoritesSure"
              >确 定</el-button
            >
          </div>
        </el-dialog>
        <el-table
          :data="favoritesGridData"
          height="300px"
          style="cursor: pointer"
          highlight-current-row
          @current-change="handleCurrentChange"
        >
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              <el-radio
                :label="scope.row.row"
                v-model="radio"
                @change.native="getTemplateRow(scope.$index, scope.row)"
              ></el-radio>
            </template>
          </el-table-column>
          <el-table-column
            property="name"
            label="收藏夹"
            width="400"
          ></el-table-column>
          <el-table-column
            property="create_time"
            label="修改时间"
          ></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="outerVisible = false">取 消</el-button>
          <el-button @click="innerVisible = true">新建收藏夹</el-button>
          <el-button type="primary" @click="handleSelectFavoritesSure"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';
import { getAnnulusOption } from '@/utils/echartsOption.js';

export default {
  name: 'CourseDetails',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      query: {
        id: this.$route.params.id,
        from: this.$route.query.from,
        fromId: this.$route.query.fromId,
      },
      queryNote: {
        courseId: this.$route.params.id,
        pageIndex: 1,
        pageSize: 6,
      },
      queryEvaluation: {
        courseId: this.$route.params.id,
        pageIndex: 1,
        pageSize: 6,
      },
      queryDiscuss: {
        courseId: this.$route.params.id,
        pageIndex: 1,
        pageSize: 6,
      },
      queryFeedback: {
        courseId: this.$route.params.id,
        pageIndex: 1,
        pageSize: 6,
      },
      model: {},
      rindex: 0,
      rindex1: 0,
      rto: '',
      rfrom: '',
      replyContent: '',
      replyContent1: '',
      tab: 'tab1',
      certificate: '无证书',
      noteContent: '',
      evaluationContent: '',
      discussContent: '',
      feedbackContent: '',
      isEvaluation: false,
      isFeedback: false,
      myEvaluationScore: 0,
      noteList: [],
      courseList: {},
      examList: [],
      evaluationList: [],
      feedbackList: [],
      discussList: [],
      isLiked: false,
      isClickLike: false,

      shareDialogVisible: false,

      // 收藏相关--begin
      currentRow: null,
      isStorage: false,
      innerVisible: false,
      outerVisible: false,
      favoritesGridData: [],
      radio: '',
      templateSelection: {},
      form: {
        id: 0,
        name: '',
        description: '',
      },
      formLabelWidth: '60px',
      rules: {
        name: [
          { required: true, message: '请输入收藏夹名称', trigger: 'blur' },
        ],
      },
      studyscore: {},
      // 收藏相关--end
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.$router.go(0);
    },
  },
  methods: {
    loadData() {
      this.getCourseDetails();
      this.getRelatedCourses();
    },

    loadNoteData() {
      this.getMyCourseNotes();
    },
    editNote(noteId) {
      document.getElementById('note_div_' + noteId).style.display = 'block';
    },
    loadEvaluationData() {
      this.getCourseEvaluation();
    },
    loadDiscussData() {
      this.getCourseDiscuss();
    },
    loadFeedbackData() {
      this.getCourseFeedback();
    },
    // 点赞/取消点赞
    btnLike() {
      if (this.isClickLike) {
        return;
      }
      this.isClickLike = true;
      const submitData = {
        tenant_id: this.query.id,
        tenant_type: 'Course',
      };
      if (!this.isLiked) {
        // 点赞
        this.$api.likes
          .addLikes(submitData)
          .then((response) => {
            if (response.data.code === 200) {
              this.$message.success(response.data.message);
              this.isLiked = true;
            }
            this.isClickLike = false;
          })
          .catch((error) => {
            console.log(error);
            this.isClickLike = false;
          });
      } else {
        // 取消收藏
        this.$api.likes
          .cancelLikes(submitData)
          .then((response) => {
            if (response.data.code === 200) {
              this.$message.success(response.data.message);
              this.isLiked = false;
            }
            this.isClickLike = false;
          })
          .catch((error) => {
            console.log(error);
            this.isClickLike = false;
          });
      }
    },
    // 点击收藏按钮
    btnStorage() {
      // this.isStorage = !this.isStorage;
      // console.log(this.isStorage);
      if (!this.isStorage) {
        this.outerVisible = true;
        this.getFavoritesTree();
      } else {
        const submitData = {
          tenant_id: this.query.id,
          tenant_type: 'Course',
          is_collected: !this.isStorage,
        };
        // 取消收藏
        this.cancelToFavorites(submitData);
      }
    },
    // 创建文件夹
    handleCreateFavoritesSure() {
      const submitData = {
        id: this.form.id,
        name: this.form.name,
        description: this.form.description,
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 请求
          // console.log(submitData);
          this.postFavorites(submitData);
        }
      });
    },
    // 关闭窗口：点击取消
    handleCloseFavorites() {
      this.innerVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.form.resetFields();
      });
    },
    // 关闭窗口：点击X
    handleCloseDialog() {
      this.$refs.form.resetFields();
    },
    // 获取选中行：收藏夹
    getTemplateRow(index, row) {
      this.templateSelection = row;
    },
    // 点击行选中
    handleCurrentChange(row) {
      // 如果没有row,终止
      if (!row) {
        return;
      }
      // 把当前行label绑定的值和v-model绑定的值相同时,单选按钮就可以选中
      this.radio = row.row;
      this.templateSelection = row;
    },
    // 确定选择收藏夹
    handleSelectFavoritesSure() {
      if (this.templateSelection.id === undefined) {
        this.$message.warning('请选择一个收藏夹');
        return;
      }
      const submitData = {
        favorites_id: this.templateSelection.id,
        name: this.templateSelection.name,
        description: this.form.description,
        tenant_id: this.query.id,
        tenant_type: 'Course',
        is_collected: !this.isStorage,
      };
      // console.log(submitData);
      this.addToFavorites(submitData);
    },
    // 提交笔记
    btnSubmitCourseNote(noteId) {
      // 笔记内容
      const noteContent = (
        noteId === 0
          ? this.noteContent
          : document.getElementById('note_txt_' + noteId).value
      ).trim();
      // 提交数据
      const submitData = {
        id: noteId,
        course_id: this.query.id,
        content: noteContent,
      };
      if (noteContent.length === 0) {
        this.$message.warning('请输入笔记内容');
        return;
      }
      // console.log(submitData);
      this.postCourseNote(submitData);
    },
    // 删除笔记
    btnDelCourseNote(noteId) {
      this.$confirm('此操作将永久删除该笔记, 是否继续?', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.delCourseNote(noteId);
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
    // 提交评价
    btnSubmitCourseEvaluation() {
      // 提交数据
      const submitData = {
        course_id: this.query.id,
        score: this.myEvaluationScore,
        content: this.evaluationContent,
      };
      if (this.myEvaluationScore === 0) {
        this.$message.warning('请输入评价分数');
        return;
      }
      // console.log(submitData);
      this.postCourseEvaluation(submitData);
    },
    // 提交讨论
    btnSubmitCourseDiscuss() {
      // 提交数据
      const submitData = {
        course_id: this.query.id,
        content: this.discussContent,
      };

      // console.log(submitData);
      this.postCourseDiscuss(submitData);
    },
    // 提交反馈
    btnSubmitCourseFeedback() {
      // 提交数据
      const submitData = {
        course_id: this.query.id,
        content: this.feedbackContent,
      };

      // console.log(submitData);
      this.postCourseFeedback(submitData);
    },
    // 考试
    handleExamClick(item) {
      switch (item.browse_percent) {
        case 100:
          // 可考次数不限 或 可考次数大于已考次数 才可以进入考试
          if (
            item.exam_paper.allow_times === 0 ||
            item.exam_paper.allow_times > item.exam_paper.answer_times
          ) {
            this.$confirm(
              `确定要参加【${item.exam_paper.name}】考试吗？`,
              '提示',
              {
                type: 'info',
              }
            ).then(() => {
              window.open(
                `/exam/answer/${item.exam_paper.id}?from=course&fromId=${item.id}&isRequired=${this.$route.query.isRequired}`,
                'ExamAnswer'
              );
            });
          } else {
            this.$message.warning({ message: '考试次数超出限制' });
          }
          break;
        default:
          this.$message.warning({ message: '课程未完成，无法参加考试' });
          break;
      }
    },
    changeCommenter(name, i) {
      this.evaluationList.items[this.rindex].input_show = false;
      this.rto = name;
      this.rindex = i;
      this.evaluationList.items[i].input_show = true;
    },
    _inputShow(i) {
      return this.evaluationList.items[i].input_show;
    },
    canelCommit() {
      this.replyContent = '';
      this.evaluationList.items[this.rindex].input_show = false;
    },
    addComment(i) {
      // 提交数据
      const submitData = {
        reply_content: this.replyContent,
        course_id: this.$route.params.id,
        evaluation_info_id: this.evaluationList.items[i].id,
        reviewers: this.evaluationList.items[i].create_user_name,
      };
      if (this.replyContent === 0) {
        this.$message.warning('请输入回复内容');
        return;
      }
      // console.log(submitData);
      this.postCourseEvaluationReply(submitData);
      //let a={};
      //a.reply_content=this.replyContent;
      //a.create_time=this.getTime();
      //a.course_id=this.$route.params.id;
      //a.evaluation_info_id=this.evaluationList.items[i].id;
      //a.reviewers=this.evaluationList.items[i].create_user_name;
      //this.evaluationList.items[i].course_evaluation_reply_list.push(a);

      this.replyContent = '';
      this.evaluationList.items[i].input_show = false;
    },
    changeCommenter1(name, i) {
      this.discussList.items[this.rindex1].input_show = false;
      this.rto = name;
      this.rindex1 = i;
      this.discussList.items[i].input_show = true;
    },
    _binputkShow1(i) {
      return this.discussList.items[i].input_show;
    },
    canelCommit1() {
      this.replyContent1 = '';
      this.discussList.items[this.rindex1].input_show = false;
    },
    addComment1(i) {
      // 提交数据
      const submitData = {
        reply_content: this.replyContent1,
        course_id: this.$route.params.id,
        discuss_info_id: this.discussList.items[i].id,
        reviewers: this.discussList.items[i].create_user_name,
      };
      if (this.replyContent1 === 0) {
        this.$message.warning('请输入回复内容');
        return;
      }
      // console.log(submitData);
      this.postCourseDiscussReply(submitData);
      //let a={};
      //a.reply_content=this.replyContent;
      //a.create_time=this.getTime();
      //a.course_id=this.$route.params.id;
      //a.discuss_info_id=this.discussList.items[i].id;
      //a.reviewers=this.discussList.items[i].create_user_name;
      //this.discussList.items[i].course_discuss_reply_list.push(a);

      this.replyContent1 = '';
      this.discussList.items[i].input_show = false;
    },
    getTime() {
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      let day = now.getDate();
      month = month.length < 2 ? '0' + month : month;
      day = day.length < 2 ? '0' + day : day;
      return year + '-' + month + '-' + day;
    },
    // 问卷
    handleQstClick(item) {
      switch (item.browse_percent) {
        case 100:
          if (
            item.questionnaire.answer_status === 0 ||
            item.questionnaire.answer_status === 2
          ) {
            this.$confirm(
              `确定要参加【${item.questionnaire.name}】问卷吗？`,
              '提示',
              {
                type: 'info',
              }
            ).then(() => {
              window.open(
                `/questionnaire/answer/${item.questionnaire.id}?from=course&fromId=${item.id}`,
                'QstAnswer'
              );
            });
          } else {
            this.$message.warning({ message: '您已经完成本次问卷' });
          }
          break;
        default:
          this.$message.warning({ message: '课程未完成，无法参加考试' });
          break;
      }
    },
    // 获取课程详情
    async getCourseDetails() {
      const response = await this.$api.course.getCourseDetails(this.query);
      if (response.data.code === 200) {
        this.model = response.data.data;
        this.isEvaluation = this.model.my_evaluation_score > 0;
        this.isFeedback = this.model.feedback_count > 0;
        this.myEvaluationScore = this.model.my_evaluation_score;
        this.isStorage = this.model.is_collected;
        this.isLiked = this.model.is_liked;
        // 进度图表
        this.$nextTick(() => {
          this.renderChart('myProcessChart', this.model.browse_percent, 100);
        });
      } else if (response.data.code === 404) {
        this.$message.error({
          message: '对不起，您查看的课程不存在！',
          onClose: () => {
            location.href = '/';
          },
        });
      } else {
        this.$message.error({
          message: '出错啦，请联系管理员！',
          onClose: () => {
            location.href = '/';
          },
        });
      }
    },
    // 获取我的笔记
    async getMyCourseNotes() {
      const response = await this.$api.course.getMyCourseNotes(this.queryNote);
      this.noteList = response.data.data;
    },
    // 提交笔记
    async postCourseNote(myNote) {
      const response = await this.$api.course.postCourseNote(myNote);
      if (response.data.code === 200) {
        this.noteContent = '';
        this.loadNoteData();
        this.$message.success(response.data.message);
        if (myNote.id > 0) {
          document.getElementById('note_div_' + myNote.id).style.display =
            'none';
        }
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 删除笔记
    async delCourseNote(noteId) {
      const response = await this.$api.course.delCourseNote({ id: noteId });
      if (response.data.code === 200) {
        this.loadNoteData();
        this.$message.success('删除成功!');
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 获取评价
    async getCourseEvaluation() {
      const response = await this.$api.course.getCourseEvaluation(
        this.queryEvaluation
      );
      this.evaluationList = response.data.data;
    },
    // 获取讨论
    async getCourseDiscuss() {
      const response = await this.$api.course.getCourseDiscuss(
        this.queryDiscuss
      );
      this.discussList = response.data.data;
    },
    // 获取反馈
    async getCourseFeedback() {
      const response = await this.$api.course.getCourseFeedback(
        this.queryFeedback
      );
      this.feedbackList = response.data.data;
    },
    // 提交评价内容
    async postCourseEvaluation(myEvaluation) {
      const response = await this.$api.course.postCourseEvaluation(
        myEvaluation
      );
      if (response.data.code === 200) {
        this.isEvaluation = !this.isEvaluation;
        this.evaluationContent = '';
        this.loadEvaluationData();
        this.$message.success(response.data.message);
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 提交讨论内容
    async postCourseDiscuss(myDiscuss) {
      const response = await this.$api.course.postCourseDiscuss(myDiscuss);
      if (response.data.code === 200) {
        this.discussContent = '';
        this.loadDiscussData();
        this.$message.success(response.data.message);
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 提交反馈内容
    async postCourseFeedback(myFeedback) {
      const response = await this.$api.course.postCourseFeedback(myFeedback);
      if (response.data.code === 200) {
        this.isFeedback = !this.isFeedback;
        this.feedbackContent = '';
        this.loadFeedbackData();
        this.$message.success(response.data.message);
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 提交评价回复内容
    async postCourseEvaluationReply(myEvaluationReplay) {
      const response = await this.$api.course.postCourseEvaluationReply(
        myEvaluationReplay
      );
      if (response.data.code === 200) {
        this.loadEvaluationData();
        this.$message.success(response.data.message);
      } else {
        this.$message.warning(response.data.message);
      }
    },
    async postCourseDiscussReply(myDiscussReplay) {
      const response = await this.$api.course.postCourseDiscussReply(
        myDiscussReplay
      );
      if (response.data.code === 200) {
        this.loadDiscussData();
        this.$message.success(response.data.message);
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 相关课程
    async getRelatedCourses() {
      const response = await this.$api.course.getRelatedCourses(this.query);
      this.courseList = response.data.data;
    },
    // 获取我的收藏夹
    async getFavoritesTree() {
      const response = await this.$api.favorites.getFavoritesTree();
      this.favoritesGridData = response.data.data;
    },
    // 添加收藏
    async addToFavorites(toFavorites) {
      const response = await this.$api.favorites.addToFavorites(toFavorites);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.outerVisible = false;
        this.isStorage = !this.isStorage;
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 取消收藏
    async cancelToFavorites(myFavorites) {
      const response = await this.$api.favorites.cancelToFavorites(myFavorites);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.isStorage = !this.isStorage;
      }
    },
    // 添加收藏：提交到后台
    async postFavorites(myFavorites) {
      const response = await this.$api.favorites.postFavorites(myFavorites);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.innerVisible = false;
        // push到列表
        this.favoritesGridData.unshift({
          id: response.data.data,
          name: this.form.name,
          description: '',
          create_time: this.$moment(new Date()).format('YYYY-MM-DD HH:mm'),
          relation_count: 0,
          course_count: 0,
          knowledge_count: 0,
        });
        // 清空表单
        this.$nextTick(() => {
          this.$refs.form.resetFields();
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 笔记翻页
    handleNoteCurrentChange(val) {
      this.queryNote.pageIndex = val;
      this.loadNoteData();
    },
    // 评价翻页
    handleEvaluationCurrentChange(val) {
      this.queryEvaluation.pageIndex = val;
      this.loadEvaluationData();
    },
    // 讨论翻页
    handleDiscussCurrentChange(val) {
      this.queryDiscuss.pageIndex = val;
      this.loadDiscussData();
    },
    // 反馈翻页
    handleFeedbackCurrentChange(val) {
      this.queryFeedback.pageIndex = val;
      this.loadFeedbackData();
    },
    /**
     * @param {String} id  获取HTML div元素的 ID,
     * @param {Number} dividend  数值1，（成功个数）
     * @param {Number} divisor   数值2，（总数）
     */
    renderChart(id, dividend, divisor) {
      this.$echarts.dispose(document.getElementById(id));
      const data = [dividend, divisor - dividend];
      const colors = ['#4b7efe', '#beddff'];
      const percentage = divisor === 0 ? 0 : (dividend / divisor) * 100;
      const text = this.formatValue(percentage, 1) + '%';
      const subText = '';
      const textFontSize = 20;
      const subTextFontSize = 0;
      const option = getAnnulusOption(
        data,
        colors,
        text,
        subText,
        textFontSize,
        subTextFontSize
      );
      const charts = this.$echarts.init(document.getElementById(id));
      charts.setOption(option);
    },
    /**
     * @param {number or string} value 数值
     * @param {Number} digits 保留小数位数
     * @param {bool} returnStr 返回值是字符串（如果保留位数那么返回是一个string）
     */
    formatValue(value, digits, returnStr = false) {
      if (digits < 0) {
        // console.log('小数点后位数不能为负数');
        value = 0;
      }
      if (!value) {
        value = 0;
      }
      if (returnStr) {
        return parseFloat(value).toFixed(digits);
      }
      return parseFloat(parseFloat(value).toFixed(digits));
    },
  },
};
</script>
